
import { LightningElement, api } from 'lwc';
import { getLabelsByLanguage } from '../../../utils/languageUtil';


export default class getWetRadioOptions extends LightningElement {

    errorMessage;
    isError = false
    
    @api label = '';
    @api isRequired = false;

    @api name = `radio-${Date.now()}`;

    _options = [];
    @api 
    set options(val) {
        this._options = (val ?? []).map(opt => ({
            ...opt, label: getLabelsByLanguage(opt.label)
        }))
        this.handleOptionsRender();
    } 
    get options() {
        return this._options;
    }

    _currentValue;
    @api 
    set currentValue(value) {
        this._currentValue = value;
        this.handleOptionsRender();
    } 
    get currentValue() {
        return this._currentValue;
    }

    handleOptionsRender() {
        if (!this._options?.length) return;
        const currentValue = this._currentValue ?? this._options[0].value;
        this._options = this._options.map(opt => ({
            ...opt, checked: opt.value === currentValue
        }));
        this._currentValue = currentValue;
    }

    // Return the current selection
    @api getSelection() {
        // Get the input elements from the radio group
        const radioInputs = this.template.querySelectorAll('[data-element="radio"]');

        let selected = null;

        if (radioInputs) {
            // Find the selected radio
            selected  = Array.from(radioInputs).find(radio => radio.checked).value;
        } 

        return selected;
    }
    @api sendValues() {
        // Get the input elements from the radio group
        const radioInputs = this.template.querySelectorAll('[data-element="radio"]');

        let selected = null;

        if (radioInputs) {
            // Find the selected radio
            selected  = Array.from(radioInputs).find(radio => radio.checked).value;
        } 

        return selected;
    }
    // Trigger error
    @api errorMe(errorMessage) {
        this.errorMessage = errorMessage;
        this.handleErrorAttributes();
    }
    // Focus the first radio
    @api focusMe() {
        const radios = this.template.querySelectorAll('[data-element="radio"]');
        radios[0].focus();
    }

    // Detect when the selected radio changes
    handleChange(event) {
        if (event.target.checked) {
            this._currentValue = event.target.value;
            this.handleOptionsRender();
        }

        if (this._currentValue && this.isError) {
            // Remove the errors
            this.handleErrorAttributes(true);
        }

        if (this._currentValue) {
            this.dispatchEvent(new CustomEvent('change', { detail: this.currentValue } ));
        }
    } 

    // isRemove=false: Add name="error" && aria-describedby="error_01"  --> isRemove=true: remove the attributes
    handleErrorAttributes(isRemove=false) {
        // Get the radio groups
        const radioInputs = this.template.querySelectorAll('[data-element="radio"]');

        if (!radioInputs) return;

        // Set the error flag to the opposite of <isRemove> (false if true) 
        this.isError = !isRemove;

        if (isRemove) {
            // Reset <errorMessage>
            this.errorMessage = '';
            
            // Remove the  error attributes
            radioInputs.forEach(radio => {
                radio.setAttribute("name", "radioGroup");   // Return to the original name attribute
                radio.removeAttribute("aria-describedby"); // remove aria-describedby
            });
            return;
        }

        // Add the error attributes
        radioInputs.forEach(radio => {
            radio.setAttribute("name", "error");
            radio.setAttribute("aria-describedby", "error_01");
        });
    }
}